import {Box, Chip, ListItem, ListItemText, Stack} from '@mui/material'

import {KilnMetricStatus} from '../../shared'
import {SignalMetadata, SignalTelemetry} from '../types'
import {resolveStatus} from '../utils'

export interface AssetHealthSignalItemProps {
  signal: SignalTelemetry
  signalMetadata: SignalMetadata
  onClick: () => void
}

export const AssetHealthSignalItem = ({
  signal,
  signalMetadata,
  onClick
}: AssetHealthSignalItemProps) => {
  return (
    <ListItem
      sx={{px: 0, gap: 1, width: '100%', cursor: 'pointer', '&:hover': {bgcolor: 'action.hover'}}}
      divider
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
    >
      <Stack spacing={1} sx={{width: '100%'}}>
        <Stack direction="row" spacing={3}>
          <ListItemText
            primary={
              signal.description
                ? ` ${signal.localName} > ${signal.description}`
                : ` ${signal.localName}`
            }
          />
          <Box minWidth="fit-content">
            <KilnMetricStatus
              status={resolveStatus({
                thresholdStatus: signal.threshold.status,
                modelBreach: signal.lastModelBreach
              })}
              value={`${signal.value?.toFixed(1)} ${signal.unit}`}
            />
          </Box>
        </Stack>
        <Stack direction={{xs: 'column', md: 'row'}} spacing={1}>
          <Chip color="primary" size="small" label={signalMetadata.source} />
          <Chip size="small" label={signalMetadata.area} />
          <Chip size="small" label={signalMetadata.equipment} />
        </Stack>
      </Stack>
    </ListItem>
  )
}
